import { ListItem, ListItemProps } from "arkh";
import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { TeamIconCircle } from "../../../../../components/mobile/TeamIconCircle";
import { RoutineSectionListItem_RoutineSectionVersion$key } from "./__generated__/RoutineSectionListItem_RoutineSectionVersion.graphql";

export const RoutineSectionListItem = (
  props: {
    section: RoutineSectionListItem_RoutineSectionVersion$key;
  } & Omit<ListItemProps, "children">
) => {
  const { section, ...listProps } = props;
  const data = useFragment(
    graphql`
      fragment RoutineSectionListItem_RoutineSectionVersion on RoutineSectionVersion {
        title
        section {
          assignedTeam {
            ...TeamIconCircleComponent_Team
            name
          }
        }
      }
    `,
    section
  );
  const title = useMemo(() => {
    return data.title === null || data.title.length === 0
      ? (data.section.assignedTeam?.name ?? "")
      : data.title;
  }, [data.section.assignedTeam?.name, data.title]);

  return (
    <ListItem
      left={
        data.section.assignedTeam ? (
          <TeamIconCircle team={data.section.assignedTeam} />
        ) : null
      }
      {...listProps}
    >
      <ListItem.Title>{title}</ListItem.Title>
    </ListItem>
  );
};
